import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ApiService } from "../api.service";
import { AlertifyService } from '../_service/alertify.service';
import { ManufacturerService } from '../_service/manufacturer.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatTableDataSource, MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { EditManufacturerComponent } from './edit-manufacturer/edit-manufacturer.component';
import { CreateManufacturerComponent } from './create-manufacturer/create-manufacturer.component';

@Component({
  selector: 'companies',
  templateUrl: './manufacturer.component.html',
  styleUrls: ['./manufacturer.component.css']
})
export class ManufacturerComponent implements OnInit {
  companies;
  isLoading = false;
  errorMessage = false;
  searchString: any;
  selectedParameter = 'searchString';
  selectedSearchParameter: any;
  emptySearchResponse: any = {};
  manufacturer: any = [];
  allManufacturers: any = [];
  MyDataSource: any;
  searchResultIsEmpty = true;
  message: any;
  value = '';
  searchBarForm: FormGroup;
  checkProductManufacturer: any = {};
  contactLocationId: any;

  alternateName: any;

  constructor(private api: ApiService, private alertify: AlertifyService, 
    private manufacturerService: ManufacturerService,
    private dialog: MatDialog,
    public fb: FormBuilder) {
      this.searchBarForm = fb.group({
        searchStringControl: new FormControl({value: '', disabled: false}, [])
      });
    }

  unsubscribe = new Subject<void>();

  displayedColumns: string[] = [
    'manufacturerName',
    'alternateName',
    'contactLocation',
    'companyWebsite'
  ];

  @Input() totalCount: number;
  @Input() currentPage: number;
  @Input() itemsPerPage: number;
  @Input() totalItems: number;
  @Input() totalPages: number[];
  @Input() pageIndex: number;
  @Input() pageSizeOptions: number[] = [5, 10, 20];
  @Input() pageSize: number;
  @Input() nextPage: number;
  @Input() previousPage: number;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ngOnInit() {
    this.disableSearchbox(); // Set initial disabled state
  }
  setLoadingState = (isLoading) => {};

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getCompanies(searchString)
  {
    console.log("get companies ");
    console.log(this.companies)  ;
    return this.companies;
  }

  restrictDropDownParams() {
    if (this.selectedParameter === 'mfgName' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    }
    if (this.selectedParameter === 'mfgAlias' && this.searchString === '') {
      this.isLoading = false;
      this.setLoadingState(false);
      this.alertify.message('Please enter a search parameter');
      return false;
    } else {
      return true;
    }
  }

  alternateNameWordLimit(strings) {
    for (const string of strings) {
      if (string.length > 10) {
        return string.substring(0, 20) + '...';
      } else {
        return string;
      }
    }
    return 'Not available';
  }

  clearInputBox() {
    this.value = '';
    this.searchString = '';
    this.searchBarForm.controls['searchStringControl'].setValue('');
  }

  disableSearchbox() {
    if (this.selectedParameter === 'searchString') {
      this.value = '';
      this.searchString = '';
      this.searchBarForm.controls['searchStringControl'].disable();
    } else {
      this.searchBarForm.controls['searchStringControl'].enable();
    }
  }

  onSelectParameter(event) {
    this.selectedSearchParameter = event.value;
  }

  openManufacturerEditPage(manufacturerId) {
    for (const id of this.manufacturer) {
      if (manufacturerId === id.manufacturerId) {
        this.contactLocationId = id.contactLocationId;
      }
    }
      const dialogRef = this.dialog.open(EditManufacturerComponent, {
        width: '1000px',
        data: {
          manufacturerId: manufacturerId,
          contactId: this.contactLocationId
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        // returns true or false
        if (dialogRef.componentInstance.isModified) {
          this.searchManufacturers();
        }
        if (dialogRef.componentInstance.isDeleted) {
          this.selectedParameter = 'searchString';
          this.clearInputBox();
          this.searchManufacturers();
        }
      });
   
    // console.log(manufacturerId);
    // console.log(this.manufacturer);
  }

  openCreateManufacturerPage() {
    const dialogRef = this.dialog.open(CreateManufacturerComponent, {
      width: '1000px'
    });
  }

  searchForManufacturers(selectedValue: string) {
    this.allManufacturers = [];
    this.searchString = selectedValue;
    const obj: SearchObject = {
      searchAuthorityLevel: '',
      searchSiteLevel: '',
      searchLocationLevel: '',
      searchDepartmentLevel: '',
      searchSubDepartmentLevel: '',
      searchFloorLevel: ''
    };
  
    if (this.selectedSearchParameter === 'authoritylevel') {
      obj.searchAuthorityLevel = selectedValue;
    }
    if (this.selectedSearchParameter === 'sitelevel') {
      obj.searchSiteLevel = selectedValue;
    }
    if (this.selectedSearchParameter === 'locationlevel') {
      obj.searchLocationLevel = selectedValue;
    }
    if (this.selectedSearchParameter === 'departmentlevel') {
      obj.searchDepartmentLevel = selectedValue;
    }
    if (this.selectedSearchParameter === 'subDepartmentlevel') {
      obj.searchSubDepartmentLevel = selectedValue;
    }
    if (this.selectedSearchParameter === 'floorlevel') {
      obj.searchFloorLevel = selectedValue;
    }
    this.paginator.firstPage();
    this.searchManufacturers();
  }

  invalidSearchResultMessage(message) {
    if (message) {
      this.message = message;
      this.isLoading = false;
      this.setLoadingState(false);
    } else {
      this.message = '';
    }
  }

  pageChanged(event: PageEvent) {
    this.totalItems = event.length;
    this.pageIndex = event.pageIndex;
    this.nextPage = event.pageSize;
    this.searchManufacturers();
  }

  // removeManufacturer(id) {
  //   return this.manufacturerService.deleteManufacturer(id).subscribe(
  //     res => {
  //       this.checkProductManufacturer = res.headers.get('productManufacturerExists');
  //       if (this.checkProductManufacturer) {
  //         this.alertify.error(this.checkProductManufacturer);
  //         this.isLoading = false;
  //       } else {
  //         this.alertify.success('Manufacturer successfully deleted');
  //         this.isLoading = true;
  //         this.clearInputBox();
  //         this.selectedParameter = 'searchString';
  //         this.MyDataSource.data = [];
  //         this.searchManufacturers();
  //       }
  //       this.isLoading = false;
  //     });
  // }
  searchManufacturers() {
    this.isLoading = true;
    this.setLoadingState(true);
    this.pageSize = this.pageSizeOptions[1];

    const findObj: SearchManufacturerObject = {
      mfgName: '',
      mfgAlias: '',
      searchString: '',
      pageNumber: null,
      pageSize: null,
    };

    if (this.selectedSearchParameter === 'mfgName') {
      findObj.mfgName = this.searchString.trim();
    }

    if (this.selectedSearchParameter === 'mfgAlias') {
      findObj.mfgAlias = this.searchString.trim();
    }

    if (this.selectedSearchParameter === 'searchString') {
      findObj.searchString = this.searchString;
    }

    findObj.pageNumber = this.pageIndex;
    findObj.pageSize = this.nextPage;

    if (this.restrictDropDownParams()) {
      // findProducts combined result from local database and cloudsds
      this.errorMessage = false;
      return this.manufacturerService
        .findManufacturers(findObj)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res: any) => {
            this.emptySearchResponse = res.headers.get('nosearchresult');

            if (res.body) {
              this.manufacturer = res.body;

              for (const response of this.manufacturer) {
                this.allManufacturers.push(response);
              }

              this.currentPage = JSON.parse(
                res.headers.get('pagination')
              ).currentPage;
              this.itemsPerPage = JSON.parse(
                res.headers.get('pagination')
              ).itemsPerPage;
              this.totalItems = JSON.parse(
                res.headers.get('pagination')
              ).totalItems;
              this.totalPages = JSON.parse(
                res.headers.get('pagination')
              ).totalPages;

              this.isLoading = false;
              this.setLoadingState(false);

              this.MyDataSource = new MatTableDataSource<Element>(res);
              this.MyDataSource.data = res.body;
              this.searchResultIsEmpty = false;

            } else if (this.emptySearchResponse) {
              this.invalidSearchResultMessage(this.emptySearchResponse);
              this.errorMessage = true;
              this.isLoading = false;
              this.setLoadingState(false);
              if (this.MyDataSource !== undefined) {
                this.MyDataSource.data = [];
              }

              this.searchResultIsEmpty = false;
            }
          },
          error => {
            this.searchResultIsEmpty = true;
            this.isLoading = false;
            this.setLoadingState(false);
          },
          () => {
            this.isLoading = false;
            this.setLoadingState(false);
          }
        );
    }
  }
}

export interface SearchManufacturerObject {
  mfgName: string;
  mfgAlias: string;
  searchString: string;
  pageNumber: number;
  pageSize: number;
}

export interface SearchObject {
  searchAuthorityLevel: string;
  searchSiteLevel: string;
  searchLocationLevel: string;
  searchDepartmentLevel: string;
  searchSubDepartmentLevel: string;
  searchFloorLevel: string;
}